import { render, staticRenderFns } from "./OwalSpinnerBanner.vue?vue&type=template&id=bf3e66ae&scoped=true"
import script from "./OwalSpinnerBanner.vue?vue&type=script&lang=js"
export * from "./OwalSpinnerBanner.vue?vue&type=script&lang=js"
import style0 from "./OwalSpinnerBanner.vue?vue&type=style&index=0&id=bf3e66ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf3e66ae",
  null
  
)

export default component.exports